import { translationKeys } from '@gik/create/i18n/en';
import i18n from '@gik/i18n';
import moment from 'moment';
import { checkReminder, getReminderTriggerKey, openReminder } from '../Reminder/openReminder';
import { openInkindPageSettingsModal, pageSettingsNavItemIds } from '@gik/inkind-page';

const blockName = 'recipient-address-reminder-modal';

export enum RecipientAddressReminderStorageKeyNames {
  timestamp = 'gik-recipient-address-reminder-triggered-timestamp',
  count = 'gik-recipient-address-reminder-triggered-count',
}

export function openRecipientAddressReminder(inkindRouteId: string) {
  function handleAdd() {
    openInkindPageSettingsModal({ inkindRouteId, scrollToSectionId: pageSettingsNavItemIds.recipient });
  }

  openReminder(
    blockName,
    i18n.t(translationKeys.RecipientAddressReminderTitle),
    i18n.t(translationKeys.RecipientAddressReminderDescription),
    handleAdd
  );
}

/**
 * opens the recipientAddress reminder modal if needed
 */
export function checkRecipientAddressReminder(
  inkindRouteId: string,
  pageCreatedDate: moment.Moment,
  allowMultipleReminders = false
) {
  checkReminder(
    () => openRecipientAddressReminder(inkindRouteId),
    'recipient-address-reminder',
    pageCreatedDate,
    getReminderTriggerKey(RecipientAddressReminderStorageKeyNames.timestamp, inkindRouteId),
    getReminderTriggerKey(RecipientAddressReminderStorageKeyNames.count, inkindRouteId),
    1,
    [24, 48],
    allowMultipleReminders
  );
}
